import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import * as ROUTES from '../../constants/routes';
import HelperBusiness from '../../helper/Business';
import { withTranslation } from "react-i18next";
import lang from 'i18next';



class HeaderCalendar extends Component {
  
  constructor(props) {
    super(props);
    this.state = {
      type: props.type ?? 'header',
      active: props.active ?? '',
    };
  }


  renderInsights() {
    if(HelperBusiness.getRoleIncl('admin,cs')) {
      if(this.state.type === 'header') {
        return (
          <Link to={ROUTES.CALINSIGHTS} className={this.state.active === 'insights' ? 'tab active' : 'tab'}>
            <p>{lang.t('nav:cal.insights')}</p>
            <div className="bg"></div>
          </Link>
        )
      } else {
        return (
          <Link to={ROUTES.CALINSIGHTS} className="item">
            <div className="bg"></div>
            <div className="text">{lang.t('nav:cal.insights')}</div>
          </Link>
        )
      }
    }
  }


  renderRoster() {
    if(HelperBusiness.getRoleIncl('trainer,admin')) {
      if(this.state.type === 'header') {
        return (
          <Link to={ROUTES.ROSTER} className={this.state.active === 'roster' ? 'tab active' : 'tab'}>
            <p>{lang.t('nav:cal.roster')}</p>
            <div className="bg"></div>
          </Link>
        )
      } else {
        return (
          <Link to={ROUTES.ROSTER} className="item">
            <div className="bg"></div>
            <div className="text">{lang.t('nav:cal.roster')}</div>
          </Link>
        )
      }
    }
  }


  renderRecurring() {
    if(HelperBusiness.getRoleIncl('trainer')) {
      if(this.state.type === 'header') {
        return (
          <Link to={ROUTES.RECURRING} className={this.state.active === 'recurring' ? 'tab active' : 'tab'}>
            <p>{lang.t('nav:cal.recurring')}</p>
            <div className="bg"></div>
          </Link>
        )
      } else {
        return (
          <Link to={ROUTES.RECURRING} className="item">
            <div className="bg"></div>
            <div className="text">{lang.t('nav:cal.recurring')}</div>
          </Link>
        )
      }
    }
  }


  render() {
    if(this.state.type === 'header') {
      return (
        <div className="track">
          <Link to={ROUTES.CALENDAR} className={this.state.active === 'calendar' ? 'tab active' : 'tab'}>
            <p>{lang.t('nav:cal.calendar')}</p>
            <div className="bg"></div>
          </Link>
          {this.renderRecurring()}
          {this.renderRoster()}
          {this.renderInsights()}
          <Link to={ROUTES.CALREPORT} className={this.state.active === 'reports' ? 'tab active' : 'tab'}>
            <p>{lang.t('nav:cal.reports')}</p>
            <div className="bg"></div>
          </Link>
        </div>
      )
    } else {
      return (
        <div>
          <Link to={ROUTES.CALENDAR} className="item">
            <div className="bg"></div>
            <div className="text">{lang.t('nav:cal.calendar')}</div>
          </Link>
          {this.renderRecurring()}
          {this.renderRoster()}
          {this.renderInsights()}
          <Link to={ROUTES.CALREPORT} className="item">
            <div className="bg"></div>
            <div className="text">{lang.t('nav:cal.reports')}</div>
          </Link>
        </div>
      )
    }
  }
}


export default withTranslation(['nav'])(HeaderCalendar);